import { StateParams } from "@uirouter/angularjs";
import {
  ServerUtility,
  vsName as serverUtilityName,
} from "../../../../../../records/server/serverUtility";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../../../../../shared/components/views/machines/detail/tabs";
import { MachineGateway } from "../../../../models/machine";
import { MachineConfigurationProgressiveMap } from "../../../../models/progressiveDefinition";
import { vsComponentName as MachineDetailProgressiveConfigurationComponentName } from "./component";
import { vsComponentName as MachineDetailProgressiveConfigurationEditComponentName } from "./edit/component";

machineDetailProgressiveComponentConfig.$inject = [
  MachineDetailTabsProviderName,
];
export function machineDetailProgressiveComponentConfig(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider.addElement({
    displayName: "Progressive Configuration",
    id: "progressiveConfiguration",
    uiSrefFragment: "progressiveConfiguration",
    requiredPermission: "partView",
    stateDefinition: {
      url: "/progressiveConfiguration",
      component: MachineDetailProgressiveConfigurationComponentName,
      resolve: {
        machine: ["machine", (machine: MachineGateway) => machine],
        progressiveInformation: [
          "machine",
          serverUtilityName,
          (machine: MachineGateway, serverUtility: ServerUtility) => {
            const configurations = machine.Configs ?? [];
            const configurationIds = configurations.map((c) => c.Id);
            return serverUtility
              .sendApiRequest({
                method: "POST",
                url: "/api/machines/MachineConfiguration/progressiveInformation",
                data: {
                  MachineConfigurationIds: configurationIds,
                },
              })
              .then((r: any) => r.Result);
          },
        ],
      },
    },
    children: [
      {
        id: "edit",
        displayName: "Edit",
        uiSrefFragment: "edit",
        stateDefinition: {
          component: MachineDetailProgressiveConfigurationEditComponentName,
          url: "/{machineConfigurationId:int}/edit",
          resolve: {
            machineConfiguration: [
              "machine",
              "$stateParams",
              (machine: MachineGateway, $stateParams: StateParams) => {
                const machineConfigurationId = <number>(
                  $stateParams.machineConfigurationId
                );
                return machine?.Configs?.find(
                  (c) => c.Id === machineConfigurationId
                );
              },
            ],
            machineConfigurationProgressiveInformation: [
              "progressiveInformation",
              "$stateParams",
              (
                progressiveInformation: MachineConfigurationProgressiveMap,
                $stateParams: StateParams
              ) => {
                const machineConfigurationId = <number>(
                  $stateParams.machineConfigurationId
                );
                return progressiveInformation[machineConfigurationId];
              },
            ],
          },
          bindings: {
            machine: "machine",
            machineConfiguration: "machineConfiguration",
            machineConfigurationProgressiveInformation:
              "machineConfigurationProgressiveInformation",
          },
        },
      },
    ],
  });
}
